// Pushes B2B landing funnel events to the same GTM dataLayer the site already
// boots in utils/gtm.js, instead of adding a second analytics pipeline.
export function trackB2BEvent(event, properties = {}) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...properties });
}

export default trackB2BEvent;
